import { useCallback, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { PlannedPostsLayout } from 'services/post/state'
import { useSelector, useDispatch } from 'react-redux'
import { plannedPostsLayoutSelector } from 'services/post/selectors'
import { setPlannedPostsView } from 'services/post'
import PPSwitch from 'components/PPSwitch'

interface ActiveViewSelectorProps {
  className?: string
  hideOptions?: Array<'calendar' | 'list' | 'grid'>
  value?: PlannedPostsLayout
  onChange?: (value: PlannedPostsLayout) => void
 }

export function ActiveViewSelector({ className, hideOptions, value, onChange }: ActiveViewSelectorProps) {
  const dispatch = useDispatch()
  const reduxValue = useSelector(plannedPostsLayoutSelector)
  const selectedValue = value ?? reduxValue

  const onItemClick = useCallback((next: string) => {
    const layout = next as PlannedPostsLayout
    if (onChange) {
      onChange(layout)
    } else {
      dispatch(setPlannedPostsView(layout))
    }
  }, [dispatch, onChange])

  useEffect(() => {
    if (hideOptions && hideOptions.includes(selectedValue)) {
      const availableOptions = ['calendar', 'list', 'grid'].filter(option => 
        !hideOptions.includes(option as any)
      ) as PlannedPostsLayout[]
      
      if (availableOptions.length > 0) {
        onItemClick(availableOptions[0])
      }
    }
  }, [hideOptions, onItemClick, selectedValue])

  const options = [{
    label: (
      <span>
        <FormattedMessage id="post.views.calendar" />
      </span>
    ),
    value: 'calendar'
  }, {
    label: <FormattedMessage id="post.views.timeline" />,
    value: 'list'
  }, {
    label: (
      <span>
        <FormattedMessage id="post.views.grid" />
      </span>
    ),
    value: 'grid'
  }].filter(option => !hideOptions || !hideOptions.includes(option.value as any))

  return (
    <PPSwitch
      selectedValue={selectedValue}
      options={options}
      className={className}
      id="active-view-selector"
      onSelectedValueChange={onItemClick}
    />
  )
}

export default ActiveViewSelector
